import {
    makeStyles,
    Typography, useTheme
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({

    title: {
        fontWeight: "500",
        position: "relative",
        zIndex: 1,
        "&::after": {
            content: "..",
            position: "absolute",
            left: 0,
            bottom: 0,
            height: "1px",
            width: "60px",
            borderBottom: "1px solid magenta",
        },
    },
    line: {
        height: "3px",
        width: "50px",
        backgroundColor: "#FEB969"
    },

}));

export default function AdminTitle2(props) {
    const theme = useTheme();
    const classes = useStyles();

    return (

        <div>
            <Typography
                variant="h6"
                style={{ color: theme.palette.darkIndigo.main }}
            >
                {props.subTitle}
            </Typography>

            {
                !props.disableLine &&
                <div className={classes.line}></div>
            }

        </div>
    );
}
